<div class="filters">
  <div class="filters_filter">
    <div class="input-container">
      <div class="input-container_label">Shipment ID:</div>
      <input
        [formControl]="shipmentId"
        class="input-container_input input-container_input--thin"
        (input)="searchShipment($event)"
      />
    </div>
  </div>

  <div class="filters_filter">
    <div class="input-container">
      <div class="input-container_label">Contains SKU:</div>
      <input
        [formControl]="containSkus"
        class="input-container_input input-container_input--thin"
        (input)="searchShipment($event)"
      />
    </div>
  </div>

  <div class="filters_filter">
    <div class="input-container">
      <div class="input-container_label">Shipment Type:</div>
      <select
        class="input-container_input input-container_input--thin"
        (change)="searchShipment($event)"
        [formControl]="shipmentType"
      >
        <option [value]="">All</option>
        <option *ngFor="let type of fbaTypes" [value]="type.id">{{type.name}}</option>
      </select>
    </div>
  </div>

  <div class="filters_filter">
    <div class="input-container">
      <mat-checkbox
        class="font-weight-normal"
        [formControl]="boxContents"
        (change)="searchShipment($event)"
        >With box content only</mat-checkbox
      >
    </div>
  </div>
</div>
